import EditUserPopup from 'containers/Account/BasicInfo/EditUserPopup'
import { updateCompany } from 'containers/OrderDetails/basketSlice'
import usePopupState from 'hooks/usePopupState'
import { useHistory } from 'react-router-dom'
import Submit from 'components/inputs/Submit'
import { useReduxDispatch } from 'store'
import Receipt from './Receipt'

const User = ({ isDesktop, user, setData }) => {
  const { popup, openPopup } = usePopupState()
  const dispatch = useReduxDispatch()
  const { push } = useHistory()

  return (
    <>
      {popup === 'userData' && <EditUserPopup
        data={user}
        callback={response => {
          setData(prev => ({ ...prev, user: response }))
        }}
      />}
      <Receipt
        data={user}
        editAction={() => {
          openPopup('userData')
        }}
      />
      {!isDesktop && <div className='receipt__button'>
        <Submit
          text={'Dalej'}
          action={() => {
            dispatch(updateCompany(false))
            push('/order/summary')
          }} />
      </div>}
    </>
  )
}

export default User